export default {
  //  --------------------- 湖北银行 银行开始 (50)-------------
  // 出金
  param_outFund: {
    url: '/hb-bank-channel/fund/outFund',
    param: {
      bankId: 50,
      amount: 0, // 出金金额
      pwd: '' // 资金密码
    }
  },
  // 他行入金展示信息
  param_showInFundInfo50: {
    url: '/hb-bank-channel/fund/showInFundInfo',
    param: {}
  }
//  --------------------- 湖北银行 银行结束-------------
}
